VjsAdmin.OneRosterQueue = (function () {
    const me = {};

    me.$table = $('#oneroster-queue-table');
    me.platform_id = me.$table.attr('data-platform-id');
    me.district_joint_guid = me.$table.attr('data-district-joint-guid');

    // quit polling the server if too many errors happen
    me.polling_error = 0;
    me.polling_error_threshold = 2;
    me.polling_timeout = null;

    // amount of time between refreshing the table
    me.polling_interval = 4000;

    me.$queue_sync_modal = null;

    me.init = function () {
        me.initTable();

        me.$table.on('click', '.results-json-popup', function () {
            if (me.polling_timeout != null) {
                clearTimeout(me.polling_timeout);
            }
            const json = $(`#${$(this).attr('data-results-id')}`).html();
            let content = '';
            try {
                content = $('<pre>').html(JSON.stringify(JSON.parse(json), null, '\t'));
            } catch (e) {
                content = $('<h2>').html('OOPS! Malformed JSON.... must be too big to handle, man.');
            }
            const closeButton = $('<button type="button" class="btn btn-blue" data-dismiss="modal">Close</button>');
            if (me.$modal != null) {
                me.$modal.remove();
            }
            me.$modal = VjsAdmin.Modal.create({
                title: 'Results',
                body: content,
                footer: closeButton,
                onHide() {
                    me.polling_timeout = setTimeout(() => {
                        me.$table.bootstrapTable('refresh', { silent: true });
                    }, me.polling_interval);
                },
            });
            me.$modal.modal('show');
        });

        $('.queue-sync').on('click', (e) => {
            e.preventDefault();

            if (me.$queue_sync_modal == null) {
                const $queueSyncForm = $('<div>').html($('#queue-sync-form-template').html());
                const $queueItUpButton = $('<button type="button" class="btn btn-blue" data-dismiss="modal">Queue it up!</button>');
                const $cancelButton = $('<button type="button" class="btn btn-hollow-dark-gray" data-dismiss="modal">Cancel</button>');

                $queueItUpButton.on('click', (ee) => {
                    ee.preventDefault();

                    $('body').css('cursor', 'wait');
                    $('.app').addClass('light-blur');
                    $('#ajax-progress-indicator').fadeIn();

                    $.post(
                        Slim.Router.pathFor('platforms.districts.oneroster.queue.add', {
                            platform_id: me.platform_id,
                            district_joint_guid: me.district_joint_guid,
                        }),
                        $('#queue-sync-form').serialize(),
                    ).always(() => {
                        $('body').css('cursor', 'default');
                        $('.app').removeClass('light-blur');
                        $('#ajax-progress-indicator').fadeOut();

                        me.$users_table.bootstrapTable('refresh', {
                            silent: true,
                        });
                        me.$bulk_edit_modal.modal('hide');
                    });
                });

                $cancelButton.on('click', () => {
                    $('#bulk-edit-modal .modal-body .alert').remove();
                    $('#bulk-edit-modal .modal-body input').removeClass('is-invalid').removeClass('is-valid');
                });

                const $modalFooter = $('<div></div>');
                $modalFooter.append($cancelButton);
                $modalFooter.append($queueItUpButton);

                me.$queue_sync_modal = VjsAdmin.Modal.create({
                    id: 'queue-sync-modal',
                    title: 'Queue a Sync',
                    body: $queueSyncForm,
                    footer: $modalFooter,
                    no_close: true,
                    onShown() {},
                });
            }

            me.$queue_sync_modal.modal({ backdrop: 'static', keyboard: false });
        });
    };

    me.initTable = function () {
        me.$table.bootstrapTable({
            ...VjsTable.tableDefaults(),
            table: '#oneroster-queue-table',
            formatNoMatches() {
                return 'No OneRoster History (...yet)';
            },
            idField: 'queue_id',
            sortName: 'date_queued',
            sortOrder: 'DESC',
            search: false,
            url: Slim.Router.pathFor('platforms.districts.oneroster.queue.json', {
                platform_id: me.platform_id,
                district_joint_guid: me.district_joint_guid,
            }),

            onRefresh() {},
            onLoadError(status, res) {
                VjsTable.tableDefaults().onLoadError.call(this, status, res);
                // increment how many polling errors we've gotten
                me.polling_error++;

                // if we've had too many errors, don't schedule a refresh...
                if (me.polling_error <= me.polling_error_threshold) {
                    me.polling_timeout = setTimeout(() => {
                        me.$table.bootstrapTable('refresh', { silent: true });
                    }, me.polling_interval);
                }
            },
            onLoadSuccess(data) {
                VjsTable.tableDefaults().onLoadSuccess.call(this, data);

                // since we had a success, reset polling errors to 0
                me.polling_error = 0;

                // refresh the table in a lil bit
                me.polling_timeout = setTimeout(() => {
                    me.$table.bootstrapTable('refresh', { silent: true });
                }, me.polling_interval);
            },
            columns: [
                [
                    {
                        title: 'Status',
                        field: 'status',
                        align: 'center',
                        class: 'status',
                        valign: 'middle',
                        sortable: true,
                        rowspan: 2,
                    },
                    {
                        title: 'ID',
                        field: 'queue_id',
                        align: 'center',
                        valign: 'middle',
                        sortable: true,
                        rowspan: 2,
                    },
                    {
                        title: '<i class="fa fa-calendar" aria-hidden="true"></i> Queued',
                        field: 'date_queued',
                        align: 'left',
                        valign: 'middle',
                        sortable: true,
                        rowspan: 2,
                    },
                    {
                        title: '<i class="fa fa-calendar" aria-hidden="true"></i> Started',
                        field: 'date_started',
                        align: 'left',
                        valign: 'middle',
                        sortable: false,
                        rowspan: 2,
                    },
                    {
                        title: '<i class="fa fa-calendar" aria-hidden="true"></i> Last Action',
                        field: 'date_last_action',
                        align: 'center',
                        valign: 'middle',
                        sortable: true,
                        rowspan: 2,
                    },
                    {
                        title: '<i class="fa fa-calendar" aria-hidden="true"></i> Finished',
                        field: 'date_finished',
                        align: 'center',
                        valign: 'middle',
                        sortable: true,
                        rowspan: 2,
                    },
                    {
                        title: 'Size',
                        field: 'file_size',
                        align: 'center',
                        valign: 'middle',
                        sortable: true,
                        rowspan: 2,
                    },
                    {
                        title: 'Mode',
                        field: 'mode',
                        align: 'center',
                        valign: 'middle',
                        sortable: true,
                        rowspan: 2,
                    },
                    {
                        title: 'Users',
                        field: 'status',
                        align: 'center',
                        valign: 'middle',
                        sortable: false,
                        colspan: 6,
                    },
                    {
                        title: 'Classes',
                        field: 'status',
                        align: 'center',
                        valign: 'middle',
                        sortable: false,
                        colspan: 6,
                    },
                    {
                        title: 'Enrollments',
                        field: 'status',
                        align: 'center',
                        valign: 'middle',
                        sortable: false,
                        colspan: 4,
                    },
                    {
                        title: 'Errors',
                        field: 'number_of_errors',
                        align: 'center',
                        valign: 'middle',
                        sortable: true,
                        rowspan: 2,
                    },
                    {
                        title: 'Action',
                        field: 'actions',
                        align: 'center',
                        valign: 'middle',
                        sortable: false,
                        rowspan: 2,
                    },
                ],
                [
                    {
                        title: 'T',
                        field: 'users_total',
                        align: 'center',
                        valign: 'middle',
                        sortable: false,
                    },
                    {
                        title: 'C',
                        field: 'users_created',
                        align: 'center',
                        valign: 'middle',
                        sortable: false,
                    },
                    {
                        title: 'U',
                        field: 'users_updated',
                        align: 'center',
                        valign: 'middle',
                        sortable: false,
                    },
                    {
                        title: 'D',
                        field: 'users_deleted',
                        align: 'center',
                        valign: 'middle',
                        sortable: false,
                    },
                    {
                        title: 'S',
                        field: 'users_skipped',
                        align: 'center',
                        valign: 'middle',
                        sortable: false,
                    },
                    {
                        title: 'F',
                        field: 'users_failed',
                        align: 'center',
                        valign: 'middle',
                        sortable: false,
                    },
                    {
                        title: 'T',
                        field: 'classes_total',
                        align: 'center',
                        valign: 'middle',
                        sortable: false,
                    },
                    {
                        title: 'C',
                        field: 'classes_created',
                        align: 'center',
                        valign: 'middle',
                        sortable: false,
                    },
                    {
                        title: 'U',
                        field: 'classes_updated',
                        align: 'center',
                        valign: 'middle',
                        sortable: false,
                    },
                    {
                        title: 'D',
                        field: 'classes_deleted',
                        align: 'center',
                        valign: 'middle',
                        sortable: false,
                    },
                    {
                        title: 'S',
                        field: 'classes_skipped',
                        align: 'center',
                        valign: 'middle',
                        sortable: false,
                    },
                    {
                        title: 'F',
                        field: 'classes_failed',
                        align: 'center',
                        valign: 'middle',
                        sortable: false,
                    },
                    {
                        title: 'T',
                        field: 'enrollments_total',
                        align: 'center',
                        valign: 'middle',
                        sortable: false,
                    },
                    {
                        title: 'U',
                        field: 'enrollments_updated',
                        align: 'center',
                        valign: 'middle',
                        sortable: false,
                    },
                    {
                        title: 'S',
                        field: 'enrollments_skipped',
                        align: 'center',
                        valign: 'middle',
                        sortable: false,
                    },
                    {
                        title: 'F',
                        field: 'enrollments_failed',
                        align: 'center',
                        valign: 'middle',
                        sortable: false,
                    },
                ],
            ],
            responseHandler(res) {
                const formattedResult = {};
                formattedResult.total = res.meta.total;
                formattedResult.rows = res.data;

                $(formattedResult.rows).each((i, result) => {
                    // we're getting a UTC date from the DB... need to convert it to the users timezone...?
                    const dateFormat = 'MM/DD/YYYY';
                    const timeagoArray = [];
                    const row = VjsAdmin.convertDateRow(result, dateFormat, timeagoArray);

                    const size = Math.floor(Math.log(row.file_size) / Math.log(1024));
                    const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
                    if (row.file_size) {
                        row.file_size = `${(row.file_size / 1024 ** i).toFixed(2) * 1} ${sizes[size]}`;
                    }

                    /* eslint-disable no-undef */
                    row.users_total = number_format(row.users_total);
                    row.users_created = number_format(row.users_created);
                    row.users_updated = number_format(row.users_updated);
                    row.users_deleted = number_format(row.users_deleted);
                    row.users_skipped = number_format(row.users_skipped);
                    row.users_failed = number_format(row.users_failed);

                    row.classes_total = number_format(row.classes_total);
                    row.classes_created = number_format(row.classes_created);
                    row.classes_updated = number_format(row.classes_updated);
                    row.classes_deleted = number_format(row.classes_deleted);
                    row.classes_skipped = number_format(row.classes_skipped);
                    row.classes_failed = number_format(row.classes_failed);

                    row.enrollments_total = number_format(row.enrollments_total);
                    row.enrollments_updated = number_format(row.enrollments_updated);
                    row.enrollments_skipped = number_format(row.enrollments_skipped);
                    row.enrollments_failed = number_format(row.enrollments_failed);
                    /* eslint-enable no-undef */

                    row.is_active = row.active;
                    const { status } = row;

                    row.status = `<strong>${row.status}</strong>`;
                    if (status === 'completed') {
                        row.status += ' <i class="fa fa-thumbs-up text-success" aria-hidden="true"></i>';
                    }

                    row.actions = '';

                    if (status === 'processing' || status === 'queued') {
                        if (VjsAdmin.hasPermission('platforms.districts.oneroster.queue.cancel')) {
                            const cancelUrl = Slim.Router.pathFor('platforms.districts.oneroster.queue.cancel', {
                                platform_id: row.platform_id,
                                district_joint_guid: row.district_joint_guid,
                                queue_id: row.queue_id,
                            });
                            row.actions = `<form method="post" action="${cancelUrl}"><input type="hidden" name="_METHOD" value="DELETE" /><button type="submit" class="btn btn-hollow-pink">Cancel</input></form>`;
                        }
                    }

                    if (row.log_file_uri !== null && VjsAdmin.hasPermission('platforms.districts.oneroster.queue.log')) {
                        const logUrl = Slim.Router.pathFor('platforms.districts.oneroster.queue.log', {
                            platform_id: row.platform_id,
                            district_joint_guid: row.district_joint_guid,
                            queue_id: row.queue_id,
                        });
                        row.actions += `<form method="get" action="${logUrl}"><button type="submit" class="btn btn-hollow-dark-gray">Log</input></form>`;
                    }

                    if (row.number_of_errors >= 1) {
                        const template = `<script type="text/template" id="row-${row.queue_id}-results-json">${row.results_json}</script>`;
                        row.number_of_errors = `<a href="#" class="btn btn-hollow-pink results-json-popup" data-results-id="row-${
                            row.queue_id
                        }-results-json">${row.number_of_errors} error${+row.number_of_errors === 1 ? '' : 's'}</a>${template}`;
                    }

                    // eslint-disable-next-line no-underscore-dangle
                    row._data = {
                        status,
                        queue_id: row.queue_id,
                    };
                });
                return formattedResult;
            },
        });
    };

    return {
        init: me.init,
    };
}());
